import React from 'react';
import TextField from '../../../Components/textField/textField';
import Button from '../../../Components/commonButton/commonButton'
import moment from 'moment';
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import Select from '../../../Components/select/select'
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css"

export default class Ordens extends React.Component {
  state = {
    code: "",
    production_batch: "  ",
    piece_code: "",
    machines: [],
    items: [],
    id_machine: 0,
    piece_hour: 0,
    piece_production: 0,
    show: false,
    message: "",
    code_machine: null,
    piece_cicle: null,
    id_piece: 0,
    id_item: 0,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  }

  componentDidMount() {
    Api.get('/machines/').then((resp) => {
      let arr = []
      resp.data.forEach(element => {
        arr.push({ value: element.id, label: element.description + element.code })
      });
      this.setState({ machines: arr })
    })
    Api.get('/items/').then((resp) => {
      let arr = []
      resp.data.forEach(element => {
        arr.push({ value: element.id, label: element.code+' - '+ element.description })
      });
      this.setState({ items: arr })
    })
  }

  callBackCode = (child) => { this.setState({ code: child }) }
  
  callbackfunction = () => { this.setState({ show: false }) }
  callBackPieceCode = (value,label) =>{
    this.setState({id_item:value,piece_code:label.split('-')[0].trim()})
  }
  callBackPieceProduction = (value) =>{
    this.setState({piece_production:value})
  }
  sendData = () => {
    if ((this.state.code !== "" && this.state.code !== null) && (this.state.id_item !== 0) &&
      (this.state.piece_production !== 0 && this.state.piece_production !== null && this.state.piece_production !== "." && this.state.piece_production !== "")) {
      Api.post('/production-orders/', [{
        code: this.state.code,
        piece_code: this.state.piece_code,
        id_item: this.state.id_item,
        piece_production: this.state.piece_production.toString().slice(-1) == "." ? parseFloat(this.state.piece_production.toString().slice(0,-1)) : this.state.piece_production,
        date_created: moment().format('YYYY-MM-DD'),
        hour_created: moment().format('HH:mm:ss'),
        sibling_piece_code:""

      }]).then((res) => {
        if(res.data.status == 0){
          this.setState({ message: "Já existe uma ordem cadastrada com esse nome!", show: true })
        }else{
          this.setState({notification: true, notification_message: "Ordem cadastrada com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        }
      }).catch((error) => {
        if (error.response) {
          alert(error.response.data + '\n' + error.response.status + '\n' + error.response.headers)
        }
      }
      )
    } else {
      this.setState({ message: "Necessário preencher todos os campos corretamente.", show: true })
    }
  }

  render() {
    let { show, message, items, notification, notification_message, notification_type } = this.state
    return (
      <div className='box'>
      {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
      <div className="input_fields_add_orders form">
      <h4>Adicionar Ordem</h4>
        {this.state.show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} /> : null}
        <div className='inputs'>
          <div className='tf1AddOrder element'><TextField section={true} focus={true} title="Ordem de produção" min={3} value={this.state.code} max={30} parentCallback={this.callBackCode} validationType="varchar"/></div>
          <div className='tf1AddOrder element'><Select label="Código da peça" arrData={items} handleSelect={this.callBackPieceCode}/></div>
          <div className='tf2AddOrder element' id="qtdpecas"><TextField section={true} title="Qtd. de peças á produzir" max={6} value={this.state.piece_production} parentCallback={this.callBackPieceProduction} decimal  validationType="decimal"/></div>
        </div>
        <div className='btnAddOrder submitButton'><Button title="Enviar" parentCallback={this.sendData} /></div>
      </div>
      </div>
    )
  }
}